const cardItems = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=Home%20cinema%20setup%20with%20large%20screen%20and%20warm%20ambient%20lighting%2C%20cozy%20living%20room%20atmosphere%2C%20cinematic%20viewing%20experience%2C%20dark%20room%20with%20soft%20golden%20accent%20lights%2C%20professional%20home%20theater%20aesthetic&width=600&height=400&seq=card-01&orientation=landscape',
    title: '家庭影院搭建指南',
    desc: '用星空电影网搭配大屏设备，手把手教你打造私人影院级观影空间',
    tag: '实用教程',
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=Movie%20marathon%20night%20aesthetic%20with%20popcorn%20and%20soft%20blanket%20on%20sofa%2C%20warm%20cozy%20lighting%2C%20film%20watching%20atmosphere%2C%20snacks%20and%20drinks%20setup%2C%20relaxing%20home%20evening%20vibe&width=600&height=400&seq=card-02&orientation=landscape',
    title: '周末电影马拉松清单',
    desc: '精心挑选的10部高分电影连播计划，从午后到深夜的完美观影路线',
    tag: '观影计划',
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=Smartphone%20watching%20movie%20on%20public%20transport%20with%20headphones%2C%20warm%20evening%20light%2C%20mobile%20streaming%20aesthetic%2C%20commute%20entertainment%2C%20modern%20lifestyle%2C%20urban%20atmosphere&width=600&height=400&seq=card-03&orientation=landscape',
    title: '通勤追片省流量技巧',
    desc: '手机端智能缓存策略详解，地铁公交上看高清电影不耗过多流量',
    tag: '技巧分享',
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=Classic%20film%20posters%20collection%20on%20gallery%20wall%20with%20warm%20lighting%2C%20vintage%20cinema%20aesthetic%2C%20film%20history%20display%2C%20artistic%20composition%2C%20cultural%20heritage%20vibe&width=600&height=400&seq=card-04&orientation=landscape',
    title: '影史必看百部经典',
    desc: '从默片时代到数字纪元，跨越百年的电影艺术精华片单整理',
    tag: '片单推荐',
  },
  {
    id: 5,
    image: 'https://readdy.ai/api/search-image?query=Family%20watching%20movie%20together%20on%20sofa%20with%20warm%20lighting%2C%20parents%20and%20children%20enjoying%20film%2C%20cozy%20living%20room%2C%20happy%20family%20moment%2C%20weekend%20entertainment%2C%20wholesome%20atmosphere&width=600&height=400&seq=card-05&orientation=landscape',
    title: '亲子观影精选合集',
    desc: '适合全家一起看的温暖电影推荐，从动画到成长故事一网打尽',
    tag: '家庭时光',
  },
  {
    id: 6,
    image: 'https://readdy.ai/api/search-image?query=Director%20film%20storyboard%20and%20camera%20equipment%20on%20wooden%20desk%2C%20warm%20studio%20lighting%2C%20filmmaking%20process%20aesthetic%2C%20creative%20workspace%2C%20cinematography%20planning%2C%20behind%20the%20scenes%20atmosphere&width=600&height=400&seq=card-06&orientation=landscape',
    title: '看懂电影：镜头语言入门',
    desc: '导演如何用画面讲故事？十分钟带你理解电影视听语言的魅力',
    tag: '影迷进阶',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-3">
            观影指南
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            从设备搭建到片单规划，让你的观影体验更上一层楼
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {cardItems.map((item) => (
            <article
              key={item.id}
              className="bg-background-200/60 rounded-lg overflow-hidden border border-background-300/30 hover:border-primary-500/20 transition-all duration-200 group cursor-pointer"
            >
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 object-top"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    if (target.parentElement) {
                      target.parentElement.style.display = 'none';
                    }
                  }}
                />
                <div className="absolute top-3 left-3">
                  <span className="text-xs bg-secondary-500 text-background-950 font-semibold px-2.5 py-1 rounded whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm font-semibold text-foreground-200 mb-2 group-hover:text-primary-400 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}